<template>
  <v-container>
    <v-row v-if="list">
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <v-card outlined width="100%">
          <v-card-title>{{ list.title }}</v-card-title>
          <v-card-text>{{ list.description }}</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn v-if="list.closed"
              text
              color="info"
              :loading="openCloseLoading"
              @click="open"
            >Open</v-btn>
            <v-btn
              v-else
              text
              color="warning"
              :loading="openCloseLoading"
              @click="close"
            >Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <film-table :query="query" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FilmTable from "@/components/films/FilmTable"

export default {
  name: "List",
  components: {
    FilmTable,
  },
  props: {
    id: {
      type: String | Number,
      required: true,
    },
  },
  data() {
    return {
      list: null,
      openCloseLoading: false,
    }
  },
  inject: ["httpClient"],
  mounted() {
    this.load()
  },
  computed: {
    query() {
      return {
        in_list: this.id
      }
    }
  },
  methods: {
    async load() {
      this.list = await this.httpClient.loadList({
        id: this.id,
      })
    },
    async open() {
      this.openCloseLoading = true
      await this.httpClient.openList({
        id: this.id,
      })
      this.list.closed = false
      this.openCloseLoading = false
    },
    async close() {
      this.openCloseLoading = true
      await this.httpClient.closeList({
        id: this.id,
      })
      this.list.closed = true
      this.openCloseLoading = false
    },
  },
  watch: {
    id() {
      this.load()
    },
  },
}
</script>
